export enum AceOpportunityTypeEnum {
  FLAT_RENEWAL = 'Flat Renewal',
  EXPANSION = 'Expansion',
  NET_NEW_BUSINESS = 'Net New Business',
}
